export default "__VITE_ASSET__DO4Jua_8__"